module.exports = __webpack_public_path__ + "ad7e36f05b0b2cca8523245888386ec2.png";